export default {
  nav: {
    dashboard: '儀表板',
    teams: '球隊與名單',
    masterManagement: '聯賽與球員主檔管理',
    videoAnalytics: '影片與 AI 分析',
    training: '技能與體能專案',
    recruiting: '大學球探與升學管道',
    playerRecruiting: '職業球探與升學',
    parentRecruiting: '大學球探與升學中心',
    lineup: '先發與守備打序',
    liveGame: '即時計分與球數',
    events: '賽程與出席管理',
    billing: '金流與服務訂閱 (Stripe)',
    settings: '組織設定',
    management: '管理選單',
    adminMenu: '球隊管理員作業',
    coachMenu: '教練專用選單',
    playerMenu: '球員專區',
    parentMenu: '家長入口',
    activeContext: '當前組織環境',
    switchRole: '切換視角身分:',
    switchPerspective: '切換檢視視角',
    signOut: '登出 (Clerk)',
    createJoinOrg: '建立 / 加入組織',
    clerkOrgs: '所屬組織列表 (租戶)',
    notifications: '通知',
    playerHub: '球員主頁',
    playerRoster: '球隊名冊',
    playerLineup: '比賽打序表',
    playerSchedule: '日程與出席回覆',
    playerBilling: '球員費用與Stripe繳費',
    parentHub: '家長專區',
    parentDirectory: '球隊名冊與通訊錄',
    parentLogistics: '行程與接送規劃',
    parentLineup: '比賽先發確認',
    parentBilling: '隊費與加值服務繳費',
  },
  tenantReg: {
    pageTitle: '棒球組織與球團註冊',
    pageSubtitle: '於 Clerk 建立您的多租戶組織，並自動同步管理者帳號與組織 ID 至後端伺服器。',
    step1Label: '1. 組織管理者帳號註冊',
    step2Label: '2. 棒球球團組織設定',
    managerTip: '請建立主要的組織最高管理者帳號 (Org Admin)，該帳號將擁有組織名單、金流訂閱與球隊設定之完整權限。',
    fullName: '管理者真實姓名',
    workEmail: '公務電子信箱 (Clerk 登入帳號)',
    phoneOptional: '聯絡電話 (選填)',
    password: '密碼',
    alreadyHaveAccount: '已經有帳號？立即登入',
    continueToOrg: '前往球團組織設定',
    orgTip: '設定棒球球團基本資訊，系統將自動產生 Clerk Organization ID 並轉發至後端 API。',
    orgNameLabel: '棒球組織 / 球團名稱',
    typeLabel: '租戶類型 (Tenant Type)',
    tierLabel: '租戶類型',
    types: {
      PRO: '職業 (Pro)',
      AMATEUR: '業餘 / 社會人 (Amateur)',
      ACADEMIC: '學校 / 學生 (Academic)',
      OTHERS: '其他 (Others)',
    },
    orgSlugLabel: '組織識別碼 (Slug / Clerk ID)',
    apiSyncNotice: '自動同步 userId 與 orgId 至 API 伺服器',
    backToManager: '返回管理者資訊',
    createAndLaunch: '註冊組織並啟動工作區',
    successTitle: '組織註冊成功！',
    successMsg: '已成功建立 {org} (管理者: {user})，正在同步至後端 API...',
    sportTypeLabel: '運動項目 (Sport Type)',
    seasonYearLabel: '賽季年份',
    enterCodeLabel: '輸入 6 位數驗證碼',
    resendCode: '重新發送驗證碼',
    resendingCode: '正在重發驗證碼...',
    verifyContinue: '驗證並繼續',
    editEmail: '變更電子郵件',
    autoFillSocial: '使用社群帳號快速帶入：',
    orEnterCredentials: '或手動輸入帳號密碼',
    clerkModalBtn: 'Clerk 視窗模式',
    passwordPolicyNote: '依據 Clerk 安全政策密碼長度須至少 15 個字元',
    nativeScopingBadge: '自有資料庫多租戶範疇隔離',
    selectedBadge: '已選取',
  },
  master: {
    title: '聯賽球隊與球員主檔管理',
    badge: '主檔資料庫',
    subtitle: '管理 {name} 所屬聯賽之球隊主檔、設定自隊／對手標籤，並將球員主檔綁定至租戶使用者帳號。',
    ownTeamsCount: '我方球隊 {count} 隊',
    opponentsCount: '對手球隊 {count} 隊',
    leagueTeamsTab: '聯賽球隊主檔 ({count})',
    playerMasterTab: '球員主檔與帳號綁定 ({count})',
    searchTeamsPlaceholder: '搜尋主檔球隊或聯賽名稱...',
    addMasterTeam: '新增主檔球隊',
    colTeamName: '球隊名稱',
    colLeague: '所屬聯賽 / 盃賽',
    colDivision: '組別 / 梯隊',
    colCoach: '總教練',
    colDesignation: '所屬標籤',
    colActions: '操作',
    ownClub: '我方球隊',
    opponent: '對手球隊',
    manageRoster: '管理名冊',
    scouted: '聯賽對手',
    searchPlayersPlaceholder: '搜尋球員姓名、背號或電子信箱...',
    allTeamsFilter: '主檔全部球隊',
    colJersey: '#',
    colPlayerName: '球員主檔姓名',
    colPrimaryTeam: '主要所屬球隊',
    colPosition: '守備位置',
    colLinkedUser: '已綁定租戶帳號',
    colAccountStatus: '帳號狀態',
    colUserLinkage: '使用者綁定',
    notLinked: '尚未綁定使用者',
    inviteSentText: '已發送邀請: {email}',
    linkUserBtn: '綁定使用者',
    unlinkBtn: '解除綁定',
    sendInviteTitle: '發送邀請電子郵件',
    unlinkTitle: '解除使用者帳號綁定',
    linkModalTitle: '將球員主檔綁定至租戶使用者帳號',
    linkModalEmailLabel: '租戶使用者登入信箱 (Clerk JWT 帳號)',
    linkModalEmailDesc: '當該使用者透過 Clerk 登入時，系統將自動連結至此選手之球員名冊、數據與先發打序表。',
    linkModalSubmit: '確認綁定帳號',
    addTeamModalTitle: '註冊聯賽主檔球隊',
    addTeamModalNameLabel: '球隊名稱',
    addTeamModalNamePlaceholder: '例如: 舊金山強棒 18U',
    addTeamModalLeagueLabel: '所屬聯賽 / 賽事名稱',
    addTeamModalLeaguePlaceholder: '例如: 頂級錦標賽巡迴賽 (PSC)',
    addTeamModalDivisionLabel: '梯隊組別',
    addTeamModalDivisionPlaceholder: '例如: 甲組先鋒聯賽',
    addTeamModalCoachLabel: '總教練姓名',
    addTeamModalCoachPlaceholder: '例如: 桑塔納教練',
    addTeamModalDesignationLabel: '所屬標籤',
    addTeamModalOwnOption: '我方球團 / 所屬球隊',
    addTeamModalOpponentOption: '聯賽對手球隊',
    addTeamModalSubmit: '儲存主檔球隊',
    markedOwnTeam: '已設定為我方球隊',
    markedOpponent: '已設定為聯賽對手',
    markedDesc: '已將 {name} 指定為 {role}。',
    userLinked: '租戶帳號綁定成功',
    userLinkedMsg: '已成功將選手 #{num} {name} 綁定至 Clerk 使用者帳號 ({email})。',
    userUnlinked: '已解除使用者帳號綁定',
    userUnlinkedMsg: '已解除 #{num} {name} 的使用者帳號關聯。',
    inviteDispatched: '邀請信已寄出',
    inviteDispatchedMsg: '已向 {target} 發送租戶帳號加入邀請。',
    teamRegistered: '主檔球隊註冊完成',
    teamRegisteredMsg: '已成功將 {team} 註冊於 {league} 聯賽。',
  },
  roles: {
    admin: '球隊管理員 (Elena)',
    coach: '總教練 / 管理員',
    player: '球員 (Cole #24)',
    parent: '家長 (監護人)',
    ADMIN: '組織管理員',
    COACH: '教練',
    GUARDIAN: '家長 / 監護人',
    TEAM_ADMIN: '球隊管理員',
    HEAD_COACH: '總教練',
    ORG_ADMIN: '組織管理員',
    PLAYER: '球員',
    PARENT: '家長',
  },
  videoAnalytics: {
    title: '影片分析與 4K AI 戰術回放',
    subtitle: '{name} 的高速投球軌跡、擊球初速與好球帶判讀分析',
    bookmarked: '影片已收藏',
    bookmarkedMsg: '已將 {title} 收藏至個人精華片段。',
  },
  training: {
    title: '技能培訓與生物力學中心',
    subtitle: '{name} 的球速強化訓練、每週影片作業與動作解析',
    weeklyProgramTitle: '第 4 週專項發展計畫',
    weekProgress: '本週作業達成率',
    assignedDrills: '指定作業與訓練菜單',
    done: '已完成',
    uploadDrillVideo: '上傳訓練影片作業',
    drillCompleted: '作業已打勾完成！',
    homeworkUploaded: '影片作業上傳成功',
    homeworkUploadedMsg: '訓練影片已上傳，系統已發送通知給教練群。',
  },
  billing: {
    teamAdminTitle: '球隊金流與服務訂閱管理',
    teamAdminSubtitle: '管理 {name} 的付款模式 (球隊統包／個人自付) 與 Stripe 訂閱服務',
    memberTitle: '隊費與個人服務繳費中心',
    memberSubtitle: '管理賽季個人隊費、體能技能加值課程與 Stripe 付款方式',
    managingTeam: '管理球隊金流:',
    paymentModelTitle: '球隊付款模式設定',
    paymentModelDesc: '設定球隊服務費用是由球團統包支出，或是由球員與家長個別自付。',
    teamPayment: '球隊付款 (球團統包扣款)',
    teamPaymentDesc: '所有球隊訂閱服務與隊費統一由球團主要 Stripe 信用卡扣繳。',
    individualPayment: '個人付款 (個別球員自付)',
    individualPaymentDesc: '系統將產生專屬 Stripe 繳費連結與帳單給個別球員與家長自付。',
    singleStripeInvoice: '球團代表卡統一月結扣款',
    athleteGuardianInvoices: '球員與家長由入口網站直接自付',
    paymentTypeUpdated: '付款模式已更新',
    paymentTypeUpdatedMsg: '已將 {team} 設定為 {type}。',
    servicesCatalog: '球隊加值訂閱服務清單',
    servicesCatalogSubtitle: '為球隊開通 4K 影片分析 AI、生物力學訓練與大學球探推廣功能。',
    videoAnalyticsRule: '影片分析服務為球隊整體基礎設施，僅支援「球隊付款」統包扣繳。',
    videoAnalyticsRuleNote: '已透過「球隊付款」模式開通 {name}。',
    teamOnlyBilling: '僅限球隊付款',
    supportsBilling: '支援 {type} 扣款',
    includedCore: '核心基礎功能 (已啟用)',
    manageCancel: '變更 / 取消訂閱',
    subscribeStripe: '透過 Stripe 立即訂閱',
    serviceSubscribed: '服務已成功開通',
    serviceSubscribedMsg: '已為球隊成功開通 {name}。',
    serviceCanceled: '已暫停訂閱',
    serviceCanceledMsg: '{name} 將於本計費週期結束後停止續訂。',
    coreRequired: '系統核心必選功能',
    coreRequiredMsg: 'Baseball Cloud Core 為名冊與賽程管理所必需的基礎模組。',
    memberDuesPortal: '球員帳戶與隊費繳納',
    goodStanding: '隊費繳納狀態正常',
    enrolledWith: '註冊於 {team} ({org})',
    seasonDues: '2025 賽季個人隊費',
    individualAddons: '球員個人加值訂閱課程',
    skillTrainingTitle: '技能訓練與生物力學專案',
    skillTrainingAthleteDesc: '客製化球速強化菜單、打擊影片作業與教練一對一線上指導。',
    updatePaymentMethod: '更新信用卡 / Stripe',
    changePaymentMethod: '變更 / 選擇付款方式',
    selectPaymentMethod: '選擇付款方式',
    choosePaymentMethodPrompt: '請選擇球團的主要付款方式 (信用卡、銀行虛擬帳戶轉帳、超商代碼繳費) 以開通訂閱服務。',
    payWithCard: '信用卡線上刷卡 (Stripe)',
    payWithCardDesc: 'Visa, Mastercard, JCB, AMEX 即時安全扣款。',
    payWithBank: '銀行虛擬帳戶轉帳 (Bank Transfer / 振込)',
    payWithBankDesc: '專屬虛擬帳號，支援網銀轉帳與自動對帳銷帳。',
    payWithKonbini: '便利超商代碼繳費 (Konbini)',
    payWithKonbiniDesc: '至 7-11、全家、萊爾富、Lawson 門市現金繳費。',
    manageInStripePortal: '在 Stripe 客戶中心管理',
    openStripePortal: 'Stripe 客戶門戶',
    paymentMethodTitle: '主要付款方式 (球團管理員)',
    paymentMethodSubtitle: '用於全隊服務訂閱、自動續約與加值模組扣款之主要付款方式。',
    noCardOnFile: '尚未建立付款方式。請選擇信用卡、銀行轉帳或超商代碼繳費以開通球隊服務。',
    cardOnRecord: '已綁定信用卡',
    defaultMethod: '預設付款方式',
    activeSubscriptionsTitle: '目前有效組織訂閱',
    activeSubscriptionsSubtitle: '已綁定至此組織 Stripe 帳號之運作中訂閱項目。',
    noActiveSubs: '目前無有效訂閱項目。請由下方清單選取所需方案。',
    renewsOn: '續約日: {date}',
    stripeCustomerId: 'Stripe 客戶編號:',
    coveredByTeam: '由球隊統包全額贊助',
    proceedToStripe: '前往 Stripe 完成訂閱',
    confirmPaymentMethod: '儲存並套用付款方式',
    videoAnalyticsPlayerNote: '球隊管理員已訂閱影片分析，您可免費觀看全場 4K 投打擊球分析。',
    accessGranted: '已取得完整影片分析權限',
    paymentHistory: '繳費與電子收據紀錄',
    stripeModalTitle: 'Stripe 安全線上刷卡',
    amountDueToday: '今日應付金額:',
    cardholderName: '持卡人姓名',
    cardNumber: '信用卡號碼',
    expiryDate: '有效期限',
    cvc: '背面末三碼 (CVC)',
    payWithStripe: '透過 Stripe 確認付款',
    paymentSuccess: '付款成功！',
    paymentSuccessMsg: '已成功透過 Stripe 完成 {service} 繳費，收據已寄至電子郵件。',
    coachRestrictionNotice: '教練權限：可管理球隊名冊、打擊序卡、賽事活動與席位分配。如需升級訂閱方案或變更扣款方式，請洽組織管理員。',
    pendingCancelBadge: '取消待生效 (於計費週期結束前仍可使用)',
    resumeBtn: '恢復訂閱',
    manageSeatsBtn: '席位分配管理',
    cancelTeamPlan: '取消球隊方案',
    subscribeTeamPlan: '透過 Stripe 訂閱 (Team)',
    monthlyDuesLabel: '每月費用 (強制按月扣款)：',
    setupRequiredTitle: '初始設定：設定 Stripe 付款方式並啟用服務',
    setupRequiredDesc: '歡迎使用 Next Base！請設定信用卡、銀行轉帳或超商繳費，並啟用 {org} 的營運模組。',
    stripeCheckoutLaunched: '已啟動 Stripe 結帳程序',
    redirectingToStripe: '正在前往 Stripe 以確認 {service}...',
    subscriptionActivated: '訂閱已啟用',
    subscriptionActivatedMsg: '已為 {org} 成功啟用 {service}。',
    loadingStripeElements: '正在載入安全 Stripe Elements 表單...',
    stripeSecure256: '官方 Stripe.js 安全 API',
    stripeDirect256: '採用官方 Stripe.js API 256 位元權杖化結帳',
    customerLabel: '客戶識別號：{id}',
    paylinkGenTitle: 'Stripe 付款連結產生工具',
    paylinkGenSubtitle: '分享此連結給家長或球員，即可線上收取賽季隊費。',
    copyBtn: '複製',
    doneBtn: '完成',
  },
  liveGame: {
    title: '即時比賽計分 ＆ Pitch Smart 投球數監控',
    subtitle: '{name} 的即時好壞球計數、投球數安全限制與隔日休息天數試算',
    topInning: '{inning} 局上',
    botInning: '{inning} 局下',
    inning: '第 {inning} 局',
    balls: '壞球 (B)',
    strikes: '好球 (S)',
    outs: '出局 (O)',
    atBat: '當前打者:',
    onDeck: '下一棒:',
    pitcher: '主投投手:',
    pitchCount: '總投球數',
    pitchLimit: 'Pitch Smart 上限: {limit} 球',
    restDaysRequired: '規定強制休息: {days} 天',
    quickPlays: '快速判決紀錄',
    ball: '+ 壞球',
    strike: '+ 好球 (揮空/判讀)',
    foul: '界外球',
    hitSingle: '一壘安打 (1B)',
    hitDouble: '二壘安打 (2B)',
    hitTriple: '三壘安打 (3B)',
    homeRun: '全壘打 (HR)',
    strikeout: '三振出局 (K)',
    walk: '四壞保送 (BB)',
    outInPlay: '擊出出局',
    runScored: '+ 得分進帳',
    advanceInning: '換局攻守交替',
    resetCount: '重設球數',
    gameLog: '比賽即時文字實況',
    noPlaysYet: '目前尚無紀錄，請使用上方功能鍵輸入打席紀錄。',
    liveScoreboard: '即時計分板',
    runnersOnBase: '壘上跑者',
    clearBases: '清空壘包',
    pitchRecorded: '投球已計入',
    pitchRecordedMsg: '已為投手 {pitcher} 累計至第 {count} 球',
    pitchLimitWarning: '投球數上限警告 (Pitch Smart)',
    pitchLimitWarningMsg: '{pitcher} 投手已投出 {count} 球 (需強制休息 {days} 天)。',
  },
  coachDashboard: {
    title: '球團總覽 • 教練指揮中心',
    subtitle: '{name} 的即時營運數據與狀態',
    manageTeams: '管理球隊',
    activeTeams: '現役球隊數',
    inSeason: '賽季進行中',
    activeRoster: '登錄球員數',
    total: '名球員',
    scheduledEvents: '已排程活動',
    next7Days: '未來 7 天內',
    winRate: '球團勝率',
    upcomingGames: '即將進行的比賽與訓練',
    viewAllSchedule: '檢視完整賽程',
    clubTeams: '旗下球隊',
    manage: '管理',
    confirmed: '已確認出席',
    out: '請假缺席',
    pending: '未回覆',
    game: '比賽',
    practice: '訓練',
    coach: '教練',
  },
  playerDashboard: {
    welcome: '歡迎回來，{name} 球員！',
    battingAvg: '打擊率 (AVG)',
    exitVelo: '擊球初速',
    ops: '整體攻擊指數 (OPS)',
    nextGame: '下一場預定比賽',
    firstPitch: '距離開賽還有 36 小時',
    reportTime: '集合報到時間',
    reportTimeVal: '明天 15:00 球場集合',
    uniform: '比賽球衣',
    location: '比賽場地',
    attendance: '您的出席狀態:',
    confirmedIn: '已確認 (準時參賽)',
    declinedOut: '無法出席',
    imIn: '確認參賽',
    cannotAttend: '無法出席',
    lineupAssignment: '您的先發打序與守備位置',
    startingLineup: '先發出場',
    batterHole: '第 2 棒',
    posShortstop: '守備位置: 游擊手 (SS)',
    card: '打序卡',
    coachBulletin: '教練留言板',
    coachQuote: '「週二牛棚投捕練習表現極佳。請注意：打擊練習於 16:30 準時開始，請帶齊兩套比賽球衣。」',
    coachAuthor: '— 馬庫斯 "Skip" 霍洛威 總教練',
    rsvpSuccess: '出席狀態已更新',
    rsvpSuccessMsg: '您已成功確認參加即將舉行的冠軍賽。',
    rsvpDeclined: '已記錄請假',
    rsvpDeclinedMsg: '已向霍洛威教練通知您無法出席。',
  },
  parentDashboard: {
    title: '家長專區 • {name}',
    duesPaid: '賽季隊費：已全額繳清',
    enrolledWith: '球員已註冊加入 {team} ({org})',
    gameDayDest: '比賽場地與交通資訊',
    round1: '第一輪邀請錦標賽',
    complexAddress: '球場地址:',
    dropOff: '抵達集合時間:',
    dropOffVal: '開賽前 90 分鐘 (15:00)',
    gameUniform: '當日球衣:',
    transportConfirmed: '接送與出席狀況已確認',
    athleteMarked: '監護人家長已確認球員出席。',
    update: '修改資料',
    headCoachContact: '總教練直接聯絡管道',
    medWaiver: '健康檢查與家長同意書',
    cleared: '審核通過',
    waiverMsg: '2025 年度運動員體檢表及球團責任豁免同意書已妥善歸檔。',
    rsvpSuccess: '已收到家長確認',
    rsvpSuccessMsg: '已記錄 {name} 球員於 {event} 的接送與出席安排。',
  },
  teams: {
    title: '球隊與分級梯隊',
    subtitle: '管理 {name} 旗下的球隊名冊、教練指派與賽程規劃',
    addNewTeam: '新增球隊',
    searchPlaceholder: '搜尋球隊名、梯隊或教練姓名...',
    record: '勝敗戰績 (W-L)',
    rosterSize: '球員人數',
    players: '人',
    headCoach: '總教練:',
    viewRoster: '查看名單',
    schedule: '球隊賽程',
    noTeams: '找不到相符球隊',
    noTeamsDesc: '在目前的篩選條件或組織下未建立任何球隊。',
    createFirstTeam: '建立第一支球隊',
    createModalTitle: '建立新棒球隊',
    createModalSubtitle: '在 {name} 組織下註冊新的梯隊部門',
    teamName: '球隊名稱',
    season: '賽季',
    division: '組別 / 所屬聯賽',
    teamColor: '球隊代表色',
    cancel: '取消',
    saveTeam: '儲存球隊',
    billingLabel: '收費模式:',
    teamMaster: '球團統付',
    splitDues: '個人分攤',
    paymentModel: '付款模式',
    teamMasterPayment: '球團統付扣款',
    individualPlayerDues: '球員個人會費扣款',
    syncWithApi: '與 API 同步',
    stripeBilling: 'Stripe 帳務入口',
    videoAnalyticsSubscribed: '影片分析訂閱中',
    skillTrainingSubscribed: '專項訓練訂閱中',
    createTeamFailed: '球隊建立失敗',
    teamCreatedSuccess: '已成功建立 {name} 球隊。',
  },
  roster: {
    backToTeams: '返回球隊列表',
    activeAthletes: '名現役球員',
    lineupCard: '打序卡',
    addPlayer: '新增球員',
    seatAllocations: '席位分配管理',
    searchPlaceholder: '搜尋球員姓名、背號、守備位置...',
    allPositions: '全部守備位置',
    playerName: '球員姓名',
    primaryPos: '主守備位置',
    batsThrows: '投打習慣',
    class: '畢業年份',
    status: '狀態',
    actions: '操作',
    viewProfile: '檢視檔案',
    noRecords: '找不到符合篩選條件的球員名單。',
    addModalTitle: '將球員加入名冊',
    addModalSubtitle: '為 {team} 註冊新選手',
    firstName: '名 (First Name)',
    lastName: '姓 (Last Name)',
    jersey: '球衣背號',
    position: '守備位置',
    emailOptional: '電子信箱 (選填)',
    gradYear: '預計畢業年份',
    addAthlete: '登記選手',
    playerAdded: '選手新增成功',
    playerAddedMsg: '#{num} {first} {last} 已正式加入球隊名單',
  },
  playerModal: {
    title: '選手體能數據與球探檔案',
    heightWeight: '身高 / 體重',
    exitVelocity: '擊球初速 (Exit Velo)',
    armVelocity: '傳球球速 (Arm Velo)',
    sprint60: '60 碼衝刺測速',
    availability: '出賽可用狀態',
    active: '健康可出賽',
    injured: '傷兵名單 (IL)',
    reserve: '預備保留名單',
    contacts: '球員與監護人家長聯絡方式',
    noEmail: '未登記電子郵件',
    scoutingNotes: '教練球探筆記與培訓方針',
    saveChanges: '儲存球員變更',
    profileSaved: '選手檔案已更新',
    profileSavedMsg: '數據指標與出賽狀態已成功儲存。',
    bats: '打擊習慣',
    throws: '投球慣用手',
    gradClass: '{year} 屆畢業生',
  },
  lineup: {
    title: '先發打序與守備佈陣表',
    badge: '賽前準備',
    subtitle: '為 {name} 安排 9 人先發打線與防守站位',
    autoFill: '自動最佳化排陣',
    saveCard: '儲存打序表',
    battingOrder: '打擊順序 (1 ~ 9 棒)',
    starters: '9 位先發',
    selectBatter: '-- 請選擇打者 --',
    defensivePos: '球場防守守備定位',
    synchronized: '已同步',
    cardSaved: '打序表已儲存',
    cardSavedMsg: '官方先發打序表已就緒，可進行裁判交換。',
    autoAssigned: '已自動指派先發陣容',
    autoAssignedMsg: '已自動將狀態最佳的主力選手填入 9 人先發名單。',
    clickToAssign: '點選球場上的守備位置可檢視先發球員詳細資訊。',
    shiftScheme: '守備佈陣體系:',
    shiftStandard: '標準守備深度',
    shiftInfieldIn: '內野趨前 (封殺本壘)',
    shiftPull: '右打拉擊防守佈陣',
    shiftNoDoubles: '防止長打 (深層站位)',
    fieldHelp: '點擊球場上的守備位置徽章，可凸顯該名球員及其防守深度。',
    printLineup: '列印打序卡',
  },
  events: {
    title: '賽程與活動規劃',
    subtitle: '同步 {name} 的比賽、練球時間與球員出席點名',
    scheduleEvent: '排定新活動',
    allEvents: '所有日程',
    gamesOnly: '僅看比賽',
    practices: '僅看練球',
    rollCall: '球隊點名',
    confirmed: '人確認出席',
    eventTitle: '活動名稱',
    eventType: '活動類型',
    homeAway: '主場 / 客場',
    opponent: '對手隊名 (比賽)',
    location: '比賽/訓練球場',
    eventScheduled: '日程排定成功',
    eventScheduledMsg: '{title} 已成功加入球隊行事曆。',
    attending: '出席',
    declined: '缺席',
    pending: '待回覆',
    saveRollCall: '儲存點名紀錄',
    game: '比賽',
    practice: '訓練',
    scrimmage: '隊內模擬賽 / 練習賽',
    tryout: '測試會 / 選拔會',
    home: '主場',
    away: '客場',
    syncSchedule: '重新整理賽程',
    scheduleEventError: '排定活動失敗',
  },
  attendanceModal: {
    title: '活動出席點名統計',
    markAllAttending: '全部設為「出席」',
    resetAll: '重設狀態',
    in: '出席',
    out: '缺席',
    maybe: '未定',
    saveAttendance: '儲存點名結果',
    cancel: '取消',
    successTitle: '出席紀錄已更新',
    successMsg: '已成功儲存 {title} 的點名結果。',
  },
  settings: {
    title: '組織與租戶設定',
    subtitle: '{name} 的 Clerk 多租戶環境配置與系統參數',
    metadata: '組織基本資料',
    orgName: '球團 / 俱樂部名稱',
    seasonScope: '適用賽季年份',
    savedMsg: '設定已順利更新',
    saveChanges: '儲存變更',
    apiClerk: 'API 與 Clerk JWT 攔截器串接',
    apiClerkDesc: 'Axios 將自動附加 Clerk 身分權杖與 X-Tenant-Id 多租戶辨識標頭。',
    tabConfig: '租戶基本設定',
    tabMembers: '成員管理與邀請',
    tabApi: 'API 範圍與標頭',
    membersTitle: '租戶成員與角色管理 (RBAC)',
    membersSubtitle: '管理角色權限 (ADMIN, COACH, PLAYER, GUARDIAN) 與最後管理員保護防護機制。',
    lastAdminNotice: '最後管理員防護中：組織必須維持至少 1 名活躍管理員。目前管理員數：{count} 名',
    softDeletionMode: '軟刪除 / 權限收回模式',
    colMemberName: '成員姓名',
    colEmail: '電子郵件',
    colAssignedTeam: '所屬球隊',
    colRole: '權限角色 (RBAC)',
    colAccess: '存取權限管理',
    unassigned: '尚未分配球隊',
    lastAdminBadge: '最後一名管理員',
    lastAdminTooltip: '無法變更角色：組織必須維持至少一名活躍的租戶管理員。',
    revokeTooltip: '無法撤銷權限：無法撤銷最後一名租戶管理員的存取權。',
    revokeBtn: '撤銷租戶存取權',
    revokeConfirm: '確定要撤銷 {name} 的存取權限嗎？已分配的服務席位將退回可用席次池。',
    apiScopingTitle: '自有資料庫多租戶範疇隔離',
    apiScopingSubtitle: '附加於所有後端 API 請求標頭 (/api/v1/...)',
    apiScopingDesc: '使用者身分驗證由 Clerk JWT 負責，而組織成員資格與角色權限則透過 PostgreSQL 資料模型進行隔離驗證。',
    classificationTier: '層級分類 (Tier)',
    sportType: '運動項目 (Sport Type)',
    seasonYear: '賽季年份',
  },
  seatAllocation: {
    modalTitle: '服務席位與授權分配',
    modalSubtitle: '為選手與教練分配 {service} 的簽約授權席次。',
    utilization: '席位使用率：',
    seatsContracted: '{count} 席 簽約中',
    available: '剩餘 {count} 席',
    assignSectionTitle: '分配席位給球隊成員',
    selectPlaceholder: '請選擇要分配席位的選手或職員...',
    assignBtn: '分配席位',
    capacityFullWarning: '席位已達上限 ({total}/{total})。請升級方案或撤銷未使用席位。',
    activeMembersTitle: '已分配的活躍成員 ({count} 名)',
    searchPlaceholder: '搜尋已分配成員...',
    colMember: '成員姓名',
    colRoleJersey: '角色 / 背號',
    colAssignedDate: '分配日期',
    colAction: '操作',
    noAssigned: '目前尚無成員分配至此服務。',
    unassignBtn: '解除分配',
    unassignConfirm: '確定要解除 {name} 的席位分配嗎？席位將退回可用額度。',
    ledgerBadge: 'PostgreSQL 即時席位總帳',
    close: '關閉',
    assignedSuccess: '服務席位分配成功',
    unassignedSuccess: '已解除 {name} 的席位分配',
    noServiceAssigned: '服務未分配',
  },
  capacityExceeded: {
    title: '席位合約容量已達上限',
    badge: '409 Conflict',
    defaultMsg: '請求分配的席位超過目前合約上限。',
    contractedSeats: '合約席位：',
    currentlyAllocated: '目前已分配：',
    requestedAdditional: '額外請求：',
    overage: '超額席位：',
    seatsNeeded: '尚需 +{count} 個席位',
    coachNotice: '教練權限無法直接升級訂閱方案。請聯繫組織管理員擴充球隊席位額度。',
    cancelBtn: '取消',
    upgradeBtn: '升級訂閱方案',
  },
  invoices: {
    title: '發票與付款紀錄',
    subtitle: '下載 PDF 收據發票並檢視球隊統一繳費與球員個人會費結算狀態。',
    refreshBtn: '重新整理發票',
    tabTenant: '球團統付帳單',
    tabIndividual: '個人個別帳單',
    colInvoiceNum: '發票編號',
    colDate: '開立日期',
    colDescription: '服務內容',
    colBilledOrg: '扣款組織',
    colAthletePayer: '球員 / 付款人',
    colService: '訂閱服務',
    colAmount: '金額',
    colStatus: '狀態',
    colDownload: '收據下載',
    noTenantInvoices: '尚無球團統付發票紀錄。',
    noIndividualInvoices: '尚無個人付款發票紀錄。',
    pdfBtn: 'PDF',
  },
  memberInvite: {
    drawerTitle: '邀請球隊成員',
    infoTip: '受邀成員將收到確認信，並可在自有租戶範疇內啟用帳號加入組織。',
    emailLabel: '成員個人 / 公務電子郵件',
    emailPlaceholder: "例如：coach.smith{'@'}example.com",
    roleLabel: '指派角色 (RBAC)',
    teamLabel: '指派至球隊 (選填)',
    teamPlaceholder: '請選擇所屬球隊...',
    rolePermissions: '角色權限說明：',
    adminDesc: '組織設定、成員管理、邀請、服務訂閱、Stripe 客戶門戶、席位分配等完整管理權限。',
    coachDesc: '管理球隊花名冊、比賽打序打擊卡、賽事/練習行程、席位分配。(無法變更付費方案與付款方式)。',
    playerDesc: '檢視個人賽程日程、出席回報、球員檔案、個人會費與加購課程付款。',
    guardianDesc: '檢視選手賽程日程、出席回報、球員檔案、個人會費與加購課程付款。',
    cancelBtn: '取消',
    sendBtn: '發送邀請信',
    successMsg: '已發送邀請信至 {email}',
    invalidEmail: '請輸入有效的電子郵件地址。',
  },
  common: {
    home: '主場',
    away: '客場',
    active: '健康出賽',
    injured: '傷兵 (IL)',
    reserve: '預備隊',
    cancel: '取消',
    save: '儲存',
    sync: '同步',
    refresh: '重新整理',
    close: '關閉',
    delete: '刪除',
    edit: '編輯',
    loading: '載入中...',
    actions: '操作',
  },
  auth: {
    signInTitle: '登入 Next Base',
    signInSubtitle: '存取您的多租戶棒球營運管理中心',
    clerkAuth: 'Clerk 驗證：',
    apiTarget: 'API 目標：',
    clientTrustTitle: 'Clerk 機器人與裝置信任驗證',
    clientTrustDesc: '根據 Clerk 安全政策 (Cloudflare Turnstile) 需進行互動式驗證。驗證完成後將自動為您登入。',
    dialogNotShowing: '未顯示驗證對話方塊？',
    openVerificationModal: '開啟 Clerk 驗證視窗',
    authNotice: '身分驗證通知',
    registerNewAccount: '註冊新組織帳號 →',
    emailLabel: '電子郵件地址',
    emailPlaceholder: "coach{'@'}diamondacademy.com",
    passwordLabel: '密碼',
    passwordPlaceholder: '請輸入您的密碼',
    signInBtn: '登入',
    clerkModalBtn: 'Clerk 視窗模式',
    registerNewOrg: '註冊新的棒球組織',
    authComplete: '身分驗證完成',
    welcomeBack: '歡迎回來，{name}！',
    missingCreds: '缺少登入資訊',
    missingCredsMsg: '請同時輸入電子郵件與密碼以進行登入。',
    authenticating: '正在驗證身分',
    connectingToClerk: '正在為 {email} 連線至 Clerk 驗證...',
    verificationRequired: '需要進行驗證',
    verificationChallenge: '請在驗證對話方塊中完成機器人安全檢查。',
    authFailed: '身分驗證失敗',
    couldNotSignIn: '無法使用提供的帳號密碼登入。',
    authSuccess: '登入成功',
    subRequired: '需要訂閱方案',
    subRequiredMsg: '請先啟用球隊訂閱方案以解鎖各項營運模組。',
    orContinueWith: '或使用社群帳號繼續',
    orSignUpWith: '或使用社群帳號註冊',
  },
  onboarding: {
    joinedOrgTitle: '您加入的組織球團',
    joinedOrgSubtitle: '您已在獨立租戶組織範疇中通過身分驗證。',
    orgType: '{type} 組織',
    enterWorkspace: '進入組織工作區',
    registerNewOrg: '註冊新的棒球組織',
  },
  lineupCard: {
    modalTitle: '官方主審先發打序卡',
    headerBadge: '官方打序與守備名單',
    division: '所屬組別',
    headCoach: '總教練',
    date: '比賽日期',
    verified: '已認證',
    num: '背號',
    pos: '守位',
    managerSig: '總教練簽名',
    umpireSig: '主審裁判簽名',
    printBtn: '列印打序卡',
  },
  recruitingHub: {
    title: 'NCAA 與職業球探升學樞紐',
    verifiedBadge: 'NCAA 認證球探資料',
    subtitle: '{name} 的大學球探資料卡、官方認證雷達數據排行榜與升學管道',
    commitsBadge: '{count} 人確定升學 (D1/D2)',
    topExitVelo: '官方認證最高擊球初速',
    fastest60: '最快 60 碼衝刺速度',
    avgGpa: '全隊平均 GPA (學業評分)',
    searchPlaceholder: '搜尋選手、就讀學校或守備位置...',
    allGradClasses: '所有畢業屆別',
    class2025: '2025 屆 (高三)',
    class2026: '2026 屆 (高二)',
    class2027: '2027 屆 (高一)',
    allStatuses: '所有升學狀態',
    uncommittedOnly: '僅看未承諾學校',
    committedOnly: '已確定升學',
    colProspect: '選手姓名',
    colClass: '屆別',
    colExitVelo: '擊球初速',
    colArmVelo: '傳球球速',
    colSixty: '60 碼測速',
    colGpa: 'GPA',
    colStatusSchool: '狀態與預計就讀',
    colScoutPacket: '球探資料包',
    uncommittedTag: '未承諾學校',
    copyLinkTitle: '複製球探認證專屬連結',
    downloadPdfTitle: '下載單頁 PDF 履歷檔案',
    dossierTitle: '官方認證大學球探專案檔案',
    peakExitVelo: '最高擊球初速',
    infieldArmVelo: '內野傳球球速',
    sixtyYardDash: '60 碼衝刺測速',
    heightWeight: '身高 / 體重',
    recruitingPipeline: '意向大學聯絡管道',
    copyRecruiterLink: '複製球探連結',
    downloadPdfPacket: '下載 PDF 資料包',
    scoutLinkCopied: '已複製球探連結',
    scoutLinkCopiedMsg: '已複製 {name} 的 NCAA 專屬球探連結',
    generatingScoutPacket: '正在產生球探資料包',
    generatingScoutPacketMsg: '正在彙整 #{num} {name} 的 TrackMan 數據與 4K 影片報告...',
  }
};